import {
  FilterContentFieldDataTypes,
  SortDirection,
  Newest,
  Oldest,
  AlphabeticalAsc,
  AlphabeticalDesc,
  IFilter,
  SortDropdownOption
} from '@hevoio/hevo-ui-toolkit';
import { TargetStatusEnum } from '../../../activate-target/models/target-status';

export const TARGET_FILTERS: IFilter[] = [
  {
    title: 'Status',
    filterKey: 'status',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      selectMode: true,
      options: TargetStatusEnum.toArray().map(s => ({
        ...s,
        label: s.name
      })),
      textFieldProps: {
        prefixIcon: 'search',
        placeholder: 'Search By Status'
      }
    }
  }
];

export const TARGET_SORT_DROPDOWN_OPTIONS: SortDropdownOption[] = [
  {
    label: Newest,
    key: 'id',
    direction: SortDirection.DESC
  },
  {
    label: Oldest,
    key: 'id',
    direction: SortDirection.ASC
  },
  {
    label: AlphabeticalAsc,
    key: 'name',
    direction: SortDirection.ASC
  },
  {
    label: AlphabeticalDesc,
    key: 'name',
    direction: SortDirection.DESC
  }
];
